const ProgressBar = ({ solved, total, difficulty, setShowResetModal }) => {
  const percentage = total > 0 ? (solved / total) * 100 : 0;
  console.log(percentage);

  return (
    <div className="mb-4 mt-2 mx-3">
      <div className="flex justify-between mb-2">
        <h2 className="font-semibold">
          Solved Progress{' '}
          {difficulty !== 'all' && ` - ${difficulty.charAt(0).toUpperCase() + difficulty.slice(1)}`}
          <span
            className="font-normal text-blue-600 cursor-pointer hover:underline"
            onClick={() => setShowResetModal(true)}
          >
            (Reset)
          </span>
        </h2>
        <span>
          {solved} / {total}
        </span>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-blue-500 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
